'use client';

import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import Link from 'next/link';
import { useState, useRef, useEffect, useCallback } from 'react';
import Modal from 'react-modal';
import '@/app/_styles/react-modal-swatch.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronRight } from '@awesome.me/kit-94e593bf23/icons/sharp/regular';
import { faXmark, faDownload, faHeart as faHeartLight } from '@awesome.me/kit-94e593bf23/icons/sharp/light';
import { faExpand } from '@awesome.me/kit-94e593bf23/icons/classic/light';
import { faMagnifyingGlassPlus } from '@awesome.me/kit-94e593bf23/icons/classic/regular';
import { faCheck } from '@awesome.me/kit-94e593bf23/icons/sharp/solid';
import { faHiveHeartLight, faHiveIconSmallLight } from '@awesome.me/kit-94e593bf23/icons/kit/custom';
import Tooltip from '@/app/_components/Tooltip';
import { faHeart } from '@awesome.me/kit-94e593bf23/icons/classic/solid';
import { toCurrency } from '@/app/_lib/services/ClientUtil';
import Price from '@/app/_components/Price';
import { useGlobalMessage } from '@/app/_lib/hooks';
import addSwatchFavoriteAction from '@/app/_lib/actions/AddSwatchFavoriteAction';
import removeSwatchFavoriteAction from '@/app/_lib/actions/RemoveSwatchFavoriteAction';
import getSwatchFavoritesAction from '@/app/_lib/actions/GetSwatchFavoritesAction';
import SwatchLines from './SwatchLines';
import SwatchFavorites from './SwatchFavorites';
const BUTTON_TYPE_IMAGES = {
  1: 'color-swatches-1-bright.png',
  2: 'color-swatches-2-medium.png',
  3: 'color-swatches-3-muted.png'
};
const SwatchSetModal = t0 => {
  const $ = _c(148);
  const {
    swatchSet,
    selectSwatch,
    selectedSwatch,
    swatchSetErrors,
    displayErrors,
    swatchFavorites: t1,
    productInfo
  } = t0;
  t1 === undefined ? [] : t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [];
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  useEffect(_temp, t2);
  const showToast = useGlobalMessage();
  const [activeTab, setActiveTab] = useState("swatches");
  const [isOpen, setIsOpen] = useState(false);
  const [currentSwatch, setCurrentSwatch] = useState(false);
  const [favoritesCount, setFavoritesCount] = useState(0);
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {};
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const [localSwatchFavorites, setLocalSwatchFavorites] = useState(t3);
  const [swatchViewerOpen, setSwatchViewerOpen] = useState(false);
  let t4;
  let t5;
  if ($[2] !== isOpen) {
    t4 = () => {
      if (isOpen) {
        const fetchFavorites = async () => {
          const response = await getSwatchFavoritesAction();
          if (response.success) {
            setFavoritesCount(response.data.count);
            const favoritesObj = {};
            response.data.favorites.forEach(fav => {
              favoritesObj[fav.swatch_id] = fav;
            });
            setLocalSwatchFavorites(favoritesObj);
          }
        };
        fetchFavorites();
      }
    };
    t5 = [isOpen];
    $[2] = isOpen;
    $[3] = t4;
    $[4] = t5;
  } else {
    t4 = $[3];
    t5 = $[4];
  }
  useEffect(t4, t5);
  const afterOpenModal = _temp2;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => {
      document.body.style.overflow = "unset";
      setIsOpen(false);
    };
    $[5] = t6;
  } else {
    t6 = $[5];
  }
  const closeModal = t6;
  let t7;
  if ($[6] !== selectedSwatch) {
    t7 = () => {
      setCurrentSwatch(selectedSwatch || false);
      setActiveTab("swatches");
      setIsOpen(true);
    };
    $[6] = selectedSwatch;
    $[7] = t7;
  } else {
    t7 = $[7];
  }
  const openSwatchSet = t7;
  let t8;
  if ($[8] !== selectedSwatch) {
    t8 = () => {
      setCurrentSwatch(selectedSwatch || false);
      closeModal();
    };
    $[8] = selectedSwatch;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const closeSwatchSet = t8;
  let t9;
  if ($[10] !== selectSwatch || $[11] !== swatchSet.swatch_set_id || $[12] !== swatchSet.swatch_set_label) {
    t9 = swatch => {
      swatch.swatch_set_id = swatchSet.swatch_set_id;
      swatch.swatch_set_label = swatchSet.swatch_set_label;
      selectSwatch(swatch);
      closeModal();
    };
    $[10] = selectSwatch;
    $[11] = swatchSet.swatch_set_id;
    $[12] = swatchSet.swatch_set_label;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  const handleAddToProduct = t9;
  let t10;
  if ($[14] !== closeSwatchSet) {
    t10 = event => {
      event.preventDefault();
      event.stopPropagation();
      closeSwatchSet();
    };
    $[14] = closeSwatchSet;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  const handleCoverClick = t10;
  const handleBigSwatchClick = _temp3;
  let t11;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = tab => {
      setActiveTab(tab);
    };
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  const handleTabClick = t11;
  let t12;
  if ($[17] !== currentSwatch || $[18] !== localSwatchFavorites || $[19] !== showToast || $[20] !== swatchSet.swatch_set_label) {
    t12 = async () => {
      if (!currentSwatch?.swatch_id) {
        return;
      }
      if (localSwatchFavorites[currentSwatch.swatch_id]) {
        const response_0 = await removeSwatchFavoriteAction(currentSwatch.swatch_id);
        if (response_0.success) {
          setFavoritesCount(response_0.data.count);
          setLocalSwatchFavorites(response_0.data.favorites);
          showToast({
            message: `${currentSwatch.swatch_name} was removed from your favorites.`,
            messageType: "success"
          });
        } else {
          showToast({
            message: response_0.message || "Error removing from favorites",
            messageType: "error"
          });
        }
        return;
      }
      const swatchData = {
        swatch_id: currentSwatch.swatch_id,
        swatch_photo: currentSwatch.swatch_photo,
        swatch_name: currentSwatch.swatch_name,
        swatch_code: currentSwatch.swatch_code,
        swatch_line_name: currentSwatch.swatch_line_name,
        swatch_line_description: currentSwatch.swatch_line_description,
        swatch_set_label: swatchSet?.swatch_set_label,
        no_samples: currentSwatch.no_samples || 0
      };
      const response_1 = await addSwatchFavoriteAction(swatchData);
      if (response_1.success) {
        setFavoritesCount(response_1.data.count);
        setLocalSwatchFavorites(response_1.data.favorites);
        showToast({
          message: response_1.message,
          messageType: "success"
        });
      } else {
        showToast({
          message: response_1.message || "Error adding to favorites",
          messageType: "error"
        });
      }
    };
    $[17] = currentSwatch;
    $[18] = localSwatchFavorites;
    $[19] = showToast;
    $[20] = swatchSet.swatch_set_label;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  const toggleFavorite = t12;
  let t13;
  if ($[22] !== localSwatchFavorites || $[23] !== showToast || $[24] !== swatchSet.swatch_set_label) {
    t13 = async swatch_0 => {
      if (!swatch_0?.swatch_id) {
        return;
      }
      if (localSwatchFavorites[swatch_0.swatch_id]) {
        const response_2 = await removeSwatchFavoriteAction(swatch_0.swatch_id);
        if (response_2.success) {
          setFavoritesCount(response_2.data.count);
          setLocalSwatchFavorites(response_2.data.favorites);
          showToast({
            message: `${swatch_0.swatch_name} was removed from your favorites.`,
            messageType: "success"
          });
        } else {
          showToast({
            message: response_2.message || "Error removing from favorites",
            messageType: "error"
          });
        }
        return;
      }
      const swatchData_0 = {
        swatch_id: swatch_0.swatch_id,
        swatch_photo: swatch_0.swatch_photo,
        swatch_name: swatch_0.swatch_name,
        swatch_code: swatch_0.swatch_code,
        swatch_line_name: swatch_0.swatch_line_name,
        swatch_line_description: swatch_0.swatch_line_description,
        swatch_set_label: swatchSet?.swatch_set_label,
        no_samples: swatch_0.no_samples || 0
      };
      const response_3 = await addSwatchFavoriteAction(swatchData_0);
      if (response_3.success) {
        setFavoritesCount(response_3.data.count);
        setLocalSwatchFavorites(response_3.data.favorites);
        showToast({
          message: response_3.message,
          messageType: "success"
        });
      } else {
        showToast({
          message: response_3.message || "Error adding to favorites",
          messageType: "error"
        });
      }
    };
    $[22] = localSwatchFavorites;
    $[23] = showToast;
    $[24] = swatchSet.swatch_set_label;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  const toggleSwatchFavorite = t13;
  let t14;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = async swatch_1 => {
      if (swatch_1.effective_price > 0) {
        swatch_1.display_name = `${swatch_1.swatch_name} <span class="pl-1 text-primary">+ ${toCurrency(swatch_1.effective_price)}</span>`;
      } else {
        swatch_1.display_name = swatch_1.swatch_name;
      }
      setCurrentSwatch(swatch_1);
    };
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  const handleSwatchSelect = t14;
  let t15;
  if ($[27] !== displayErrors || $[28] !== swatchSet.swatch_set_id || $[29] !== swatchSetErrors) {
    t15 = displayErrors && swatchSetErrors[swatchSet.swatch_set_id] && <div className="text-xs text-red transition-all duration-300">{swatchSetErrors[swatchSet.swatch_set_id]}</div>;
    $[27] = displayErrors;
    $[28] = swatchSet.swatch_set_id;
    $[29] = swatchSetErrors;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== openSwatchSet) {
    t16 = e => {
      e.preventDefault();
      e.stopPropagation();
      openSwatchSet();
    };
    $[31] = openSwatchSet;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== selectedSwatch || $[34] !== swatchSet.button_text || $[35] !== swatchSet.button_type || $[36] !== swatchSet.swatch_set_label) {
    t17 = selectedSwatch?.swatch_photo ? <><div className="flex flex-col items-start text-left"><span className="text-xs text-light">Selected {swatchSet.swatch_set_label} <FontAwesomeIcon icon={faCheck} className="text-primary text-2xs ml-0.5" /></span><span className="text-md">{selectedSwatch.swatch_name}{selectedSwatch.swatch_code && <span className="text-light"> ({selectedSwatch.swatch_code})</span>}{selectedSwatch.effective_price > 0 && <span className="text-primary ml-1">+ <Price amount={selectedSwatch.effective_price} /></span>}</span></div><div className="flex items-center gap-2"><Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos/${selectedSwatch.swatch_photo}`} alt={selectedSwatch.swatch_name} quality={90} width={35} height={35} sizes="35px" /><FontAwesomeIcon icon={faChevronRight} className="text-xs text-light" /></div></> : <><label className="capitalize text-md text-light group-hover:indent-1 transition-all duration-500">{swatchSet.button_text}</label><div className="flex items-center gap-2"><div className="w-[128px] h-[28px] relative"><div className="absolute -left-full top-0 w-[128px] h-[28px] transition-all duration-200 bg-white/[.20] group-hover:left-0" /><Image src={`/images/${BUTTON_TYPE_IMAGES[swatchSet.button_type] || BUTTON_TYPE_IMAGES[1]}`} alt="Select A Swatch" quality={90} width={128} height={28} sizes="128px" /></div><FontAwesomeIcon icon={faChevronRight} className="text-xs text-light" /></div></>;
    $[33] = selectedSwatch;
    $[34] = swatchSet.button_text;
    $[35] = swatchSet.button_type;
    $[36] = swatchSet.swatch_set_label;
    $[37] = t17;
  } else {
    t17 = $[37];
  }
  let t18;
  if ($[38] !== t16 || $[39] !== t17) {
    t18 = <button onClick={t16} className="group w-full flex items-center justify-between pb-1 border-b border-gray-10 hover:border-primary transition-colors">{t17}</button>;
    $[38] = t16;
    $[39] = t17;
    $[40] = t18;
  } else {
    t18 = $[40];
  }
  let t19;
  if ($[41] !== handleCoverClick) {
    t19 = <div className="absolute inset-0" onClick={handleCoverClick} />;
    $[41] = handleCoverClick;
    $[42] = t19;
  } else {
    t19 = $[42];
  }
  let t20;
  if ($[43] !== currentSwatch || $[44] !== handleAddToProduct || $[45] !== localSwatchFavorites || $[46] !== swatchSet.swatch_set_label || $[47] !== toggleFavorite) {
    t20 = currentSwatch && currentSwatch.swatch_id && <div className="pointer-events-auto mx-auto text-left w-[90%] max-w-[500px] bg-white m-5 shadow-md rounded-lg overflow-hidden" onClick={event_1 => handleBigSwatchClick(event_1)}><div className="p-2">{currentSwatch.full_size_exists ? <Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos/500/${currentSwatch.swatch_photo}`} alt={currentSwatch.swatch_name} quality={90} width={500} height={500} sizes="(max-width: 768px) 0px, 500px" className="w-full h-auto" /> : <div className="flex flex-col items-center justify-center aspect-square w-full max-w-[500px]"><Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos/${currentSwatch.swatch_photo}`} alt={currentSwatch.swatch_name} quality={90} width={200} height={200} sizes="200px" /><p className="text-xs text-light mt-2">No high-res image</p></div>}</div><div className="p-3 flex items-end justify-between"><div className="flex items-end gap-2 max-w-[50%]"><FontAwesomeIcon icon={faHiveIconSmallLight} className="text-primary text-2xl mb-1" /><div><div className="text-xs text-light mb-0.5">{swatchSet.swatch_set_label}</div><div className="text-xs font-medium">{currentSwatch.swatch_name}{currentSwatch.swatch_code && <span className="pl-0.5 text-light font-normal">({currentSwatch.swatch_code})</span>}</div></div></div><div className="flex items-center gap-2"><button onClick={() => toggleFavorite()} className="outline-none" aria-label={localSwatchFavorites[currentSwatch.swatch_id] ? "Remove from favorites" : "Add to favorites"}><FontAwesomeIcon icon={localSwatchFavorites[currentSwatch.swatch_id] ? faHeart : faHeartLight} className={`text-base ${localSwatchFavorites[currentSwatch.swatch_id] ? "text-red" : "text-light hover:text-red"}`} /></button><Tooltip content="Download swatch image" side="top" mobileMode="disabled"><Link href={`/api/swatch-download?swatch=${currentSwatch.swatch_photo}`} className="text-light hover:text-primary" aria-label="Download swatch"><FontAwesomeIcon icon={faDownload} className="text-base" /></Link></Tooltip><button onClick={e_0 => {
            e_0.preventDefault();
            e_0.stopPropagation();
            handleAddToProduct(currentSwatch);
          }} className="btn btn-xs btn-primary w-auto px-3 whitespace-nowrap shrink-0">Add to Product</button></div></div></div>;
    $[43] = currentSwatch;
    $[44] = handleAddToProduct;
    $[45] = localSwatchFavorites;
    $[46] = swatchSet.swatch_set_label;
    $[47] = toggleFavorite;
    $[48] = t20;
  } else {
    t20 = $[48];
  }
  let t21;
  if ($[49] !== t20) {
    t21 = <div className="swatch-preview hidden lg:flex absolute left-0 top-0 lg:w-1/2 h-full items-center justify-center pointer-events-none">{t20}</div>;
    $[49] = t20;
    $[50] = t21;
  } else {
    t21 = $[50];
  }
  let t22;
  if ($[51] !== productInfo) {
    t22 = productInfo?.thumb && <div className="shrink-0 w-[45px] h-[45px] relative"><Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${productInfo.thumb}`} alt={productInfo.name || "Product"} width={45} height={45} className="object-contain mix-blend-multiply" /></div>;
    $[51] = productInfo;
    $[52] = t22;
  } else {
    t22 = $[52];
  }
  let t23;
  if ($[53] !== swatchSet.swatch_set_label) {
    t23 = <span className="text-dark font-medium block">Select {swatchSet.swatch_set_label}</span>;
    $[53] = swatchSet.swatch_set_label;
    $[54] = t23;
  } else {
    t23 = $[54];
  }
  const t24 = productInfo?.name;
  let t25;
  if ($[55] !== t24) {
    t25 = <span className="text-light">{t24}</span>;
    $[55] = t24;
    $[56] = t25;
  } else {
    t25 = $[56];
  }
  let t26;
  if ($[57] !== t23 || $[58] !== t25) {
    t26 = <label className="text-2xs capitalize">{t23}{t25}</label>;
    $[57] = t23;
    $[58] = t25;
    $[59] = t26;
  } else {
    t26 = $[59];
  }
  let t27;
  if ($[60] !== t22 || $[61] !== t26) {
    t27 = <div className="flex items-center gap-3">{t22}{t26}</div>;
    $[60] = t22;
    $[61] = t26;
    $[62] = t27;
  } else {
    t27 = $[62];
  }
  let t28;
  if ($[63] !== closeSwatchSet) {
    t28 = e_1 => {
      e_1.preventDefault();
      e_1.stopPropagation();
      closeSwatchSet();
    };
    $[63] = closeSwatchSet;
    $[64] = t28;
  } else {
    t28 = $[64];
  }
  let t29;
  if ($[65] === Symbol.for("react.memo_cache_sentinel")) {
    t29 = <FontAwesomeIcon icon={faXmark} className="text-xl block" />;
    $[65] = t29;
  } else {
    t29 = $[65];
  }
  let t30;
  if ($[66] !== t28) {
    t30 = <button onClick={t28} className="p-1 outline-none text-light hover:text-primary" aria-label="Close">{t29}</button>;
    $[66] = t28;
    $[67] = t30;
  } else {
    t30 = $[67];
  }
  let t31;
  if ($[68] !== t27 || $[69] !== t30) {
    t31 = <div className="flex lg:hidden items-center justify-between px-[var(--site-padding)] py-2 bg-gray-10">{t27}{t30}</div>;
    $[68] = t27;
    $[69] = t30;
    $[70] = t31;
  } else {
    t31 = $[70];
  }
  let t32;
  if ($[71] !== closeSwatchSet) {
    t32 = e_2 => {
      e_2.preventDefault();
      e_2.stopPropagation();
      closeSwatchSet();
    };
    $[71] = closeSwatchSet;
    $[72] = t32;
  } else {
    t32 = $[72];
  }
  let t33;
  if ($[73] === Symbol.for("react.memo_cache_sentinel")) {
    t33 = <FontAwesomeIcon icon={faXmark} className="text-4xl block" />;
    $[73] = t33;
  } else {
    t33 = $[73];
  }
  let t34;
  if ($[74] !== t32) {
    t34 = <button onClick={t32} className="hidden lg:block absolute top-3 right-[var(--site-padding)] p-1 outline-none text-light hover:text-primary z-10" aria-label="Close">{t33}</button>;
    $[74] = t32;
    $[75] = t34;
  } else {
    t34 = $[75];
  }
  let t35;
  if ($[76] !== currentSwatch) {
    t35 = <div className="shrink-0">{currentSwatch && currentSwatch.swatch_id ? <button onClick={() => setSwatchViewerOpen(true)} className="relative w-[70px] h-[70px] bg-white border-1 border-gray-20 box-content p-3 lg:pointer-events-none group" aria-label="View swatch"><Image className="block shadow-md" src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos${currentSwatch.full_size_exists ? "/500" : ""}/${currentSwatch.swatch_photo}`} alt={currentSwatch.swatch_name} quality={90} width={70} height={70} sizes="70px" /><div className="flex lg:hidden absolute bottom-1 right-1 w-6 h-6 rounded-full bg-white shadow-sm items-center justify-center"><FontAwesomeIcon icon={faExpand} className="text-dark text-2xs" /></div></button> : <div className="w-[70px] h-[70px] bg-white border-1 border-gray-20 box-content p-3"><div className="w-full h-full bg-gray-5 flex flex-col items-center justify-center text-3xs text-light text-center">select a swatch</div></div>}</div>;
    $[76] = currentSwatch;
    $[77] = t35;
  } else {
    t35 = $[77];
  }
  const t36 = productInfo?.name;
  let t37;
  if ($[78] !== t36) {
    t37 = <span className="text-light">{t36}</span>;
    $[78] = t36;
    $[79] = t37;
  } else {
    t37 = $[79];
  }
  let t38;
  if ($[80] === Symbol.for("react.memo_cache_sentinel")) {
    t38 = <span className="text-gray-20 mx-2">|</span>;
    $[80] = t38;
  } else {
    t38 = $[80];
  }
  let t39;
  if ($[81] !== swatchSet.swatch_set_label) {
    t39 = <span className="text-dark">{swatchSet.swatch_set_label}</span>;
    $[81] = swatchSet.swatch_set_label;
    $[82] = t39;
  } else {
    t39 = $[82];
  }
  let t40;
  if ($[83] !== t37 || $[84] !== t39) {
    t40 = <label className="hidden lg:block text-sm font-medium capitalize mb-1">{t37}{t38}{t39}</label>;
    $[83] = t37;
    $[84] = t39;
    $[85] = t40;
  } else {
    t40 = $[85];
  }
  let t41;
  if ($[86] !== currentSwatch || $[87] !== handleAddToProduct || $[88] !== localSwatchFavorites || $[89] !== toggleFavorite) {
    t41 = currentSwatch && currentSwatch.swatch_id ? <><div className="flex items-center mb-2"><button onClick={() => toggleFavorite()} className="mr-2 shrink-0 mt-1" aria-label={localSwatchFavorites[currentSwatch.swatch_id] ? "Remove from favorites" : "Add to favorites"}><FontAwesomeIcon icon={localSwatchFavorites[currentSwatch.swatch_id] ? faHeart : faHeartLight} className={`text-lg ${localSwatchFavorites[currentSwatch.swatch_id] ? "text-red" : "text-light hover:text-red"}`} /></button><span className="text-dark text-sm">{currentSwatch.swatch_name}{currentSwatch.swatch_code && <span className="text-light"> ({currentSwatch.swatch_code})</span>}{currentSwatch.effective_price > 0 && <span className="text-primary ml-1">+ <Price amount={currentSwatch.effective_price} /></span>}</span></div><button onClick={e_3 => {
        e_3.preventDefault();
        e_3.stopPropagation();
        handleAddToProduct(currentSwatch);
      }} className="btn btn-xs btn-primary w-[180px]">Add to Product</button></> : <div className="text-sm text-light">choose an option below.</div>;
    $[86] = currentSwatch;
    $[87] = handleAddToProduct;
    $[88] = localSwatchFavorites;
    $[89] = toggleFavorite;
    $[90] = t41;
  } else {
    t41 = $[90];
  }
  let t42;
  if ($[91] !== t40 || $[92] !== t41) {
    t42 = <div className="flex flex-col min-w-0">{t40}{t41}</div>;
    $[91] = t40;
    $[92] = t41;
    $[93] = t42;
  } else {
    t42 = $[93];
  }
  let t43;
  if ($[94] !== productInfo) {
    t43 = productInfo?.thumb && <div className="hidden lg:block shrink-0 w-[65px] h-[65px] ml-auto mr-4 relative before:absolute before:z-10 before:inset-0 before:bg-black/[0.05] before:content-['']"><Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/${productInfo.thumb}`} alt={productInfo.name || "Product"} width={65} height={65} className="object-contain" /></div>;
    $[94] = productInfo;
    $[95] = t43;
  } else {
    t43 = $[95];
  }
  let t44;
  if ($[96] !== t35 || $[97] !== t42 || $[98] !== t43) {
    t44 = <div className="flex items-center gap-6 px-[var(--site-padding)] py-2 lg:py-0 lg:pt-5 lg:pb-4 xl:pb-0 bg-gray-5">{t35}{t42}{t43}</div>;
    $[96] = t35;
    $[97] = t42;
    $[98] = t43;
    $[99] = t44;
  } else {
    t44 = $[99];
  }
  let t45;
  if ($[100] === Symbol.for("react.memo_cache_sentinel")) {
    t45 = () => handleTabClick("swatches");
    $[100] = t45;
  } else {
    t45 = $[100];
  }
  const t46 = `inline-block text-xs py-1 px-8 rounded-t capitalize mr-2 ${activeTab == "swatches" ? "bg-white font-medium" : "bg-[#E1E1E1]"}`;
  let t47;
  if ($[101] !== swatchSet.swatch_set_label || $[102] !== t46) {
    t47 = <button onClick={t45} className={t46}>{swatchSet.swatch_set_label}</button>;
    $[101] = swatchSet.swatch_set_label;
    $[102] = t46;
    $[103] = t47;
  } else {
    t47 = $[103];
  }
  let t48;
  if ($[104] === Symbol.for("react.memo_cache_sentinel")) {
    t48 = () => handleTabClick("favorites");
    $[104] = t48;
  } else {
    t48 = $[104];
  }
  const t49 = `inline-block text-xs py-1 px-8 rounded-t ${activeTab == "favorites" ? "bg-white font-medium" : "bg-[#E1E1E1]"}`;
  const t50 = favoritesCount > 0 && ` (${favoritesCount})`;
  let t51;
  if ($[105] !== t49 || $[106] !== t50) {
    t51 = <button onClick={t48} className={t49}>Samples | Favorites{t50}</button>;
    $[105] = t49;
    $[106] = t50;
    $[107] = t51;
  } else {
    t51 = $[107];
  }
  let t52;
  if ($[108] !== t47 || $[109] !== t51) {
    t52 = <div className="flex justify-center md:justify-end w-full md:pr-[var(--site-padding)] mt-1">{t47}{t51}</div>;
    $[108] = t47;
    $[109] = t51;
    $[110] = t52;
  } else {
    t52 = $[110];
  }
  let t53;
  if ($[111] !== t31 || $[112] !== t34 || $[113] !== t44 || $[114] !== t52) {
    t53 = <div className="shrink-0 sticky top-0 z-10 pb-0 bg-gray-5">{t31}{t34}{t44}{t52}</div>;
    $[111] = t31;
    $[112] = t34;
    $[113] = t44;
    $[114] = t52;
    $[115] = t53;
  } else {
    t53 = $[115];
  }
  let t54;
  if ($[116] !== activeTab || $[117] !== currentSwatch || $[118] !== localSwatchFavorites || $[119] !== swatchSet || $[120] !== toggleSwatchFavorite) {
    t54 = <SwatchLines activeTab={activeTab} swatchSet={swatchSet} currentSwatch={currentSwatch} handleSwatchSelect={handleSwatchSelect} swatchFavorites={localSwatchFavorites} onToggleFavorite={toggleSwatchFavorite} />;
    $[116] = activeTab;
    $[117] = currentSwatch;
    $[118] = localSwatchFavorites;
    $[119] = swatchSet;
    $[120] = toggleSwatchFavorite;
    $[121] = t54;
  } else {
    t54 = $[121];
  }
  const t55 = productInfo?.sub_product_id;
  let t56;
  if ($[122] !== activeTab || $[123] !== favoritesCount || $[124] !== localSwatchFavorites || $[125] !== t55) {
    t56 = <SwatchFavorites activeTab={activeTab} favorites={localSwatchFavorites} setFavorites={setLocalSwatchFavorites} favoritesCount={favoritesCount} setFavoritesCount={setFavoritesCount} subProductId={t55} onClose={closeModal} />;
    $[122] = activeTab;
    $[123] = favoritesCount;
    $[124] = localSwatchFavorites;
    $[125] = t55;
    $[126] = t56;
  } else {
    t56 = $[126];
  }
  let t57;
  if ($[127] !== t54 || $[128] !== t56) {
    t57 = <div className="flex-1 overflow-y-auto">{t54}{t56}</div>;
    $[127] = t54;
    $[128] = t56;
    $[129] = t57;
  } else {
    t57 = $[129];
  }
  let t58;
  if ($[130] !== t53 || $[131] !== t57) {
    t58 = <div className="swatch-panel absolute top-0 right-0 h-full flex flex-col bg-white w-full md:w-2/3 lg:w-1/2 shadow-md">{t53}{t57}</div>;
    $[130] = t53;
    $[131] = t57;
    $[132] = t58;
  } else {
    t58 = $[132];
  }
  let t59;
  if ($[133] !== currentSwatch || $[134] !== localSwatchFavorites || $[135] !== swatchViewerOpen || $[136] !== toggleFavorite) {
    t59 = swatchViewerOpen && currentSwatch && <div className="fixed inset-0 z-[1100] flex lg:hidden items-center justify-center bg-modal-overlay p-4" onClick={() => setSwatchViewerOpen(false)}><div className="relative bg-white rounded-lg w-[90vw] max-w-[500px] max-h-[90vh] overflow-hidden" onClick={_temp4}><button onClick={() => setSwatchViewerOpen(false)} className="absolute top-2 right-2 z-10 w-8 h-8 flex items-center justify-center bg-white/80 rounded-full hover:bg-white transition-colors" title="Close"><FontAwesomeIcon icon={faXmark} className="text-lg" /></button><div className="px-[var(--site-padding)] py-4 overflow-hidden">{currentSwatch.full_size_exists ? <Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos/500/${currentSwatch.swatch_photo}`} alt={currentSwatch.swatch_name} width={500} height={500} className="max-w-full h-auto shadow-sm" style={{
            maxHeight: "calc(90vh - 80px)"
          }} /> : <div className="flex flex-col items-center justify-center"><Image src={`${process.env.NEXT_PUBLIC_RESOURCE_URL}/swatch_photos/${currentSwatch.swatch_photo}`} alt={currentSwatch.swatch_name} width={200} height={200} className="shadow-sm" /><p className="text-xs text-light mt-2">Large image not available</p></div>}<div className="mt-3 flex items-start justify-between gap-4"><div className="flex items-center min-w-0 flex-1"><button onClick={() => toggleFavorite()} className="outline-none shrink-0" aria-label={localSwatchFavorites[currentSwatch.swatch_id] ? "Remove from favorites" : "Add to favorites"}><FontAwesomeIcon icon={localSwatchFavorites[currentSwatch.swatch_id] ? faHeart : faHeartLight} className={`text-base me-2 ${localSwatchFavorites[currentSwatch.swatch_id] ? "text-red" : "text-light hover:text-red"}`} /></button><div className="text-sm font-medium break-all">{currentSwatch.swatch_name}{currentSwatch.swatch_code && <span className="pl-0.5 text-light">({currentSwatch.swatch_code})</span>}</div></div><Tooltip content="Download swatch image" side="top" mobileMode="disabled"><Link href={`/api/swatch-download?swatch=${currentSwatch.swatch_photo}`} className="text-light hover:text-primary shrink-0" aria-label="Download swatch"><FontAwesomeIcon icon={faDownload} className="text-base" /></Link></Tooltip></div></div></div></div>;
    $[133] = currentSwatch;
    $[134] = localSwatchFavorites;
    $[135] = swatchViewerOpen;
    $[136] = toggleFavorite;
    $[137] = t59;
  } else {
    t59 = $[137];
  }
  let t60;
  if ($[138] !== isOpen || $[139] !== t19 || $[140] !== t21 || $[141] !== t58 || $[142] !== t59) {
    t60 = <Modal overlayClassName="swatch-modal fixed inset-0 outline-none bg-modal-overlay z-[1000]" className="fixed inset-0 outline-none overscroll-contain" isOpen={isOpen} onAfterOpen={afterOpenModal} onRequestClose={closeModal} contentLabel="Swatch Selector" closeTimeoutMS={700}>{t19}{t21}{t58}{t59}</Modal>;
    $[138] = isOpen;
    $[139] = t19;
    $[140] = t21;
    $[141] = t58;
    $[142] = t59;
    $[143] = t60;
  } else {
    t60 = $[143];
  }
  let t61;
  if ($[144] !== t15 || $[145] !== t18 || $[146] !== t60) {
    t61 = <>{t15}{t18}{t60}</>;
    $[144] = t15;
    $[145] = t18;
    $[146] = t60;
    $[147] = t61;
  } else {
    t61 = $[147];
  }
  return t61;
};
export default SwatchSetModal;

/*
overlayClassName="outline-none slide_in_modal-dep z-[1055] fixed outline-0 top-[85px] md:top-0 bottom-0 left-0 right-0 bg-black/[.08]"
className={`outline-none z-40 absolute top-0 shadow w-4/5 md:w-2/3 xl:w-1/2 overflow-y-scroll overscroll-contain bg-white transition-all ease-out duration-700 h-full ${isOpen ? 'left-[20%] md:left-1/3 xl:left-[50%]' : 'left-full'}`}
*/
function _temp() {
  Modal.setAppElement("#app");
}
async function _temp2() {
  document.body.style.overflow = "hidden";
}
function _temp3(event_0) {
  event_0.preventDefault();
  event_0.stopPropagation();
}
function _temp4(e_4) {
  return e_4.stopPropagation();
}